export const CUSTOM_LABELS_DISPLAY_LABEL_MAX_LENGTH = 200;
export const CUSTOM_LABELS_VALUE_MAX_LENGTH = 500;
export const USER_DEFINED_FIELD_REGEX = /^userDefinedField\d+$/;
